export default __webpack_public_path__ + "static/media/642.9be94a8a.png";